import { Message } from 'element-ui';
import { getValidCardTicketStates } from '@/enums/cardTicketStates';
import { isValidVoucherStatus } from '@/enums/voucherStatuses';

const timeStampOfWeek = 5184e5;
const timeStampOfOneDay = 864e5;

function convertPositiveNumbers(array) {
  let positiveNumbers = [];
  for (let value of array) {
    if (+value > 0) positiveNumbers.push(+value);
  }
  return positiveNumbers;
}

function convertUnsignedNumbers(array) {
  let positiveNumbers = [];
  for (let value of array) {
    if (+value >= 0) positiveNumbers.push(+value);
  }
  return positiveNumbers;
}

export function getLegalQueryList(componentQueryList, routeQueryList) {
  const routeQueryListKeys = Object.keys(routeQueryList);

  if (routeQueryListKeys.includes('store_id')) {
    componentQueryList.store_id = +routeQueryList.store_id || 0;
  }

  if (routeQueryListKeys.includes('card_state')) {
    componentQueryList.card_state = routeQueryList.card_state || 0;
  }

  // 0 是合法的“老生”，不能按 truthy 判断，否则刷新后筛选条件会丢
  if (routeQueryListKeys.includes('is_new')) {
    const isNew = routeQueryList.is_new;
    componentQueryList.is_new = isNew === '0' || isNew === 0 ? 0
      : (isNew === '1' || isNew === 1 ? 1 : '');
  }

  if (routeQueryListKeys.includes('card_ticket_state')) {
    componentQueryList.card_ticket_state = routeQueryList.card_ticket_state || 0;
  }

  if (routeQueryListKeys.includes('card_ticket_states')) {
    componentQueryList.card_ticket_states = getValidCardTicketStates(routeQueryList.card_ticket_states);
  }

  if (routeQueryListKeys.includes('card_update_state')) {
    const cardUpdateStateType = typeof routeQueryList.card_update_state;
    const isSet = (cardUpdateStateType === 'string' && routeQueryList.card_update_state.length)
      || cardUpdateStateType === 'number';
    componentQueryList.card_update_state = isSet ? +routeQueryList.card_update_state : '';
  }

  if (routeQueryListKeys.includes('apply_state')) {
    const cardUpdateStateType = typeof routeQueryList.apply_state;
    const isSet = (cardUpdateStateType === 'string' && routeQueryList.apply_state.length)
      || cardUpdateStateType === 'number';
    componentQueryList.apply_state = isSet ? +routeQueryList.apply_state : '';
  }

  if (routeQueryListKeys.includes('state')) {
    const state = typeof routeQueryList.state;
    const isSet = (state === 'string' && routeQueryList.state.length)
      || state === 'number';
    componentQueryList.state = isSet ? +routeQueryList.state : '';
  }

  if (routeQueryListKeys.includes('card_type_id')) {
    componentQueryList.card_type_id = +routeQueryList.card_type_id || 0;
  }

  if (routeQueryListKeys.includes('card_payment_mode_id')) {
    componentQueryList.card_payment_mode_id = +routeQueryList.card_payment_mode_id || 0;
  }

  if (routeQueryListKeys.includes('course_column_id')) {
    componentQueryList.course_column_id = +routeQueryList.course_column_id || 0;
  }

  if (routeQueryListKeys.includes('administrator_ids')) {
    const ids = routeQueryList.administrator_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.administrator_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.administrator_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.administrator_ids = [];
    }
  }
  if (routeQueryListKeys.includes('add_administrator_ids')) {
    const ids = routeQueryList.add_administrator_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.add_administrator_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.add_administrator_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.add_administrator_ids = [];
    }
  }
  if (routeQueryListKeys.includes('update_administrator_ids')) {
    const ids = routeQueryList.update_administrator_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.update_administrator_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.update_administrator_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.update_administrator_ids = [];
    }
  }

  if (routeQueryListKeys.includes('student_ids')) {
    const ids = routeQueryList.student_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.student_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.student_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.student_ids = [];
    }
  }

  if (routeQueryListKeys.includes('issue_types')) {
    const ids = routeQueryList.issue_types;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.issue_types = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.issue_types = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.issue_types = [];
    }
  }

  if (routeQueryListKeys.includes('voucher_status')) {
    const vs = parseInt(routeQueryList.voucher_status);
    componentQueryList.voucher_status = isValidVoucherStatus(vs) ? vs : 0;
  }

  if (routeQueryListKeys.includes('apply_states')) {
    const ids = routeQueryList.apply_states;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.apply_states = convertUnsignedNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.apply_states = convertUnsignedNumbers(ids.split(','));
      }
    } else {
      componentQueryList.apply_states = [];
    }
  }

  if (routeQueryListKeys.includes('reserve_states')) {
    const ids = routeQueryList.reserve_states;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.reserve_states = convertUnsignedNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.reserve_states = convertUnsignedNumbers(ids.split(','));
      }
    } else {
      componentQueryList.reserve_states = [];
    }
  }

  if (routeQueryListKeys.includes('student_update_types')) {
    const ids = routeQueryList.student_update_types;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.student_update_types = convertUnsignedNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.student_update_types = convertUnsignedNumbers(ids.split(','));
      }
    } else {
      componentQueryList.student_update_types = [];
    }
  }

  if (routeQueryListKeys.includes('update_types')) {
    const ids = routeQueryList.update_types;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.update_types = convertUnsignedNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.update_types = convertUnsignedNumbers(ids.split(','));
      }
    } else {
      componentQueryList.update_types = [];
    }
  }

  if (routeQueryListKeys.includes('teacher_ids')) {
    const ids = routeQueryList.teacher_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.teacher_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.teacher_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.teacher_ids = [];
    }
  }

  if (routeQueryListKeys.includes('store_ids')) {
    const ids = routeQueryList.store_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.store_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.store_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.store_ids = [];
    }
  }

  if (routeQueryListKeys.includes('limit_store_ids')) {
    const ids = routeQueryList.limit_store_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.limit_store_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.limit_store_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.limit_store_ids = [];
    }
  }

  if (routeQueryListKeys.includes('card_payment_mode_ids')) {
    const ids = routeQueryList.card_payment_mode_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.card_payment_mode_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.card_payment_mode_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.card_payment_mode_ids = [];
    }
  }

  if (routeQueryListKeys.includes('card_charge_type_ids')) {
    const ids = routeQueryList.card_charge_type_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.card_charge_type_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.card_charge_type_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.card_charge_type_ids = [];
    }
  }

  if (routeQueryListKeys.includes('voucher_type_ids')) {
    const ids = routeQueryList.voucher_type_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.voucher_type_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.voucher_type_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.voucher_type_ids = [];
    }
  }

  if (routeQueryListKeys.includes('card_ticket_type_ids')) {
    const ids = routeQueryList.card_ticket_type_ids;
    if (ids) {
      if (Array.isArray(ids)) {
        componentQueryList.card_ticket_type_ids = convertPositiveNumbers(ids);
      } else if (typeof ids === 'string') {
        componentQueryList.card_ticket_type_ids = convertPositiveNumbers(ids.split(','));
      }
    } else {
      componentQueryList.card_ticket_type_ids = [];
    }
  }

  if (routeQueryListKeys.includes('date')) {
    componentQueryList.date = routeQueryList.date || '';
  }

  if (routeQueryListKeys.includes('course_type')) {
    componentQueryList.date = routeQueryList.course_type || '';
  }

  if (routeQueryListKeys.includes('keyword')) {
    componentQueryList.keyword = (routeQueryList.keyword || '').substring(0, 11);
  }

  if (routeQueryListKeys.includes('action')) {
    componentQueryList.action = (routeQueryList.action || '').substring(0, 64);
  }

  if (routeQueryListKeys.includes('level_value')) {
    const levelValue = +routeQueryList.level_value || 0;
    componentQueryList.level_value = levelValue > 0 ? levelValue : '';
  }

  if (routeQueryListKeys.includes('tag_name')) {
    componentQueryList.tag_name = (routeQueryList.tag_name || '').substring(0, 11);
  }

  if (routeQueryListKeys.includes('is_distinct')) {
    componentQueryList.is_distinct = +routeQueryList.is_distinct ? 1 : 0;
  }

  if (routeQueryListKeys.includes('is_del')) {
    componentQueryList.is_del = +routeQueryList.is_del ? 1 : 0;
  }

  if (routeQueryListKeys.includes('is_asc')) {
    componentQueryList.is_asc = +routeQueryList.is_asc ? 1 : 0;
  }

  if (routeQueryListKeys.includes('is_major')) {
    componentQueryList.is_major = +routeQueryList.is_major ? 1 : 0;
  }

  if (routeQueryListKeys.includes('is_input_error')) {
    componentQueryList.is_input_error = +routeQueryList.is_input_error ? 1 : 0;
  }

  if (routeQueryListKeys.includes('profit_state')) {
    const profitState = +routeQueryList.profit_state || 0;
    componentQueryList.profit_state = profitState >= 2 && profitState <= 4 ? profitState : '';
  }

  if (routeQueryListKeys.includes('used_scope')) {
    const usedScope = +routeQueryList.used_scope || 0;
    componentQueryList.used_scope = usedScope >= 1 && usedScope <= 2 ? usedScope : '';
  }

  if (routeQueryListKeys.includes('is_generic')) {
    const isGeneric = +routeQueryList.is_generic;
    componentQueryList.is_generic = [0, 1, 2].includes(isGeneric) ? isGeneric : 1;
  }

  if (routeQueryListKeys.includes('start_date')) {
    componentQueryList.start_date = routeQueryList.start_date || '';
  }

  if (routeQueryListKeys.includes('end_date')) {
    componentQueryList.end_date = routeQueryList.end_date || '';
  }

  if (routeQueryListKeys.includes('start_date_expire')) {
    componentQueryList.start_date_expire = routeQueryList.start_date_expire || '';
  }

  if (routeQueryListKeys.includes('end_date_expire')) {
    componentQueryList.end_date_expire = routeQueryList.end_date_expire || '';
  }

  if (routeQueryListKeys.includes('expire_number_min')) {
    componentQueryList.expire_number_min = +routeQueryList.expire_number_min || 0;
  }

  if (routeQueryListKeys.includes('expire_number_max')) {
    componentQueryList.expire_number_max = +routeQueryList.expire_number_max || 0;
  }

  if (routeQueryListKeys.includes('group_count')) {
    componentQueryList.group_count = +routeQueryList.group_count || 0;
  }

  if (routeQueryListKeys.includes('order_by')) {
    componentQueryList.order_by = routeQueryList.order_by || '';
  }

  if (routeQueryListKeys.includes('page')) {
    componentQueryList.page = routeQueryList.page > 0 ? +routeQueryList.page : 1;
  }

  if (routeQueryListKeys.includes('other_course_limit_time')) {
    componentQueryList.other_course_limit_time = routeQueryList.other_course_limit_time > 0 ? +routeQueryList.other_course_limit_time : 0;
  }

  if (routeQueryListKeys.includes('size')) {
    let size = +(routeQueryList.size || 0);
    if (size < 10) size = 10;
    componentQueryList.size = size;
  }
}

export function twoDigits(n) {
  return n > 9 ? n : `0${n}`;
}

export function getDay(date = new Date()) { // 传入时间戳 获取年-月-日 默认获取今天
  const year = date.getFullYear();
  const month = twoDigits(date.getMonth() + 1);
  const day = twoDigits(date.getDate());
  return `${year}-${month}-${day}`;
}

export function getLatelyDay(timestamp = timeStampOfOneDay) {
  const date = new Date();
  date.setTime(date.getTime() - timestamp);
  return getDay(date);
}

export function getFutureDay(timestamp = timeStampOfOneDay) {
  const date = new Date();
  date.setTime(date.getTime() + timestamp);
  return getDay(date);
}

export function getMonthStart(date = new Date()) {
  const monthStart = new Date(date.getFullYear(), date.getMonth(), 1);
  return getDay(monthStart);
}

export function getLastMonthStart(date = new Date()) {
  const lastMonthStart = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  return getDay(lastMonthStart);
}

export function getLastMonthEnd(date = new Date()) {
  const lastMonthEnd = new Date(date.getFullYear(), date.getMonth(), 0);
  return getDay(lastMonthEnd);
}

export const getNextWeek = () => getFutureDay(timeStampOfWeek);
export const getNextWeekTimeStamp = () => Date.now() + timeStampOfWeek;
export const getYesterdayTimeStamp = () => Date.now() - timeStampOfOneDay;

export function isToday(times) {
  if (!times || !times.length) return false;

  const day = getDay();
  return times[0] === day && times[1] === day;
}

export function isYesterday(times) {
  if (!times || !times.length) return false;

  const day = getLatelyDay();
  return times[0] === day && times[1] === day;
}

export function isWeek(times) {
  if (!times || !times.length) return false;

  return times[0] === getLatelyDay(timeStampOfWeek) && times[1] === getDay();
}

export function isNextWeek(times) {
  if (!times || !times.length) return false;

  return times[0] === getDay() && times[1] === getNextWeek();
}

export function isMonth(times) {
  if (!times || !times.length) return false;

  return times[0] === getLatelyDay(25056e5) && times[1] === getDay();
}

export function isCurrentMonth(times) {
  if (!times || !times.length) return false;

  return times[0] === getMonthStart() && times[1] === getDay();
}

export function isLastMonth(times) {
  if (!times || !times.length) return false;

  return times[0] === getLastMonthStart() && times[1] === getLastMonthEnd();
}

export function stringToNumberArray(str) {
  return str.split(' ').map(v => Number.isNaN(+v) ? v : +v);
}

const formats = {
  ymdHi: /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}$/,
  ymd: /^\d{4}\/\d{2}\/\d{2}$/,
};

export function getMilliseconds(timeString, format = 'ymdHi') {
  timeString = timeString.replace(/-/g, '/');
  if (!formats[format].test(timeString)) {
    return Message.error('日期选择器不兼容，请更新浏览器或选择其他浏览器！');
  }

  const millisecond = new Date(timeString).getTime();
  if (isNaN(millisecond)) {
    return Message.error('无法获取到日期，请更新浏览器或选择其他浏览器！');
  }

  return millisecond;
}

function isFebruaryFirst(timestamp) {
  const date = new Date(timestamp);
  const month = date.getMonth(); // 获取月份（0代表1月，1代表2月，依此类推）
  const day = date.getDate();   // 获取日期
  return month === 1 && day === 1;// 判断是否为2月1号
}

function isFebruaryLastDay(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear();  // 获取年份
  const month = date.getMonth();    // 获取月份

  // 获取该月的最后一天
  const lastDay = new Date(year, month + 1, 0).getDate();  // 获取2月的最后一天

  return date.getDate() === lastDay;// 判断是否为2月的最后一天
}

function isInteger(num) {
  return num % 1 === 0;
}

export function getHumanReadableTimeInterval(startTime, endTime) {
  const differenceInMillis = Math.abs(endTime + 86400000 - startTime);

  const millisInYear = 365 * 86400 * 1000;
  const yearsDifference = differenceInMillis / millisInYear;
  if (yearsDifference >= 1) return `${yearsDifference.toFixed(1)} 年`;

  if (isFebruaryFirst(startTime) && isFebruaryLastDay(endTime)) return '1 个月';

  const millisInMonth = 30 * 86400 * 1000;
  const monthsDifference = differenceInMillis / millisInMonth;
  if (monthsDifference >= 1) return `${Math.round(monthsDifference)} 个月`;

  const millisInWeek = 7 * 86400 * 1000;
  const weeksDifference = differenceInMillis / millisInWeek;
  if (isInteger(weeksDifference)) return `${Math.round(weeksDifference)} 周`;

  const millisInDay = 86400000;
  const daysDifference = differenceInMillis / millisInDay;
  if (daysDifference >= 1) return  `${Math.round(daysDifference)} 天`;

  const millisInHour = 3600000;
  const hoursDifference = differenceInMillis / millisInHour;
  if (hoursDifference >= 1) return  `${Math.round(hoursDifference)} 小时`;
}


export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);

  const year = date.getFullYear();
  let month = date.getMonth() + 1;  // 获取月份（0-11），所以加 1
  const day = date.getDate();
  /*const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');*/

  // 如果月份是个位数，去掉前导零
  if (month < 10) {
    month = month.toString();
  } else {
    month = month.toString().padStart(2, '0');
  }

  // ${hours}:${minutes}:${seconds}
  return `${year} 年 ${month} 月 ${day} 日`;
}


export const earlyAsNextWeekOfPickerOptions = {
  disabledDate(time) {
    return time.getTime() > getNextWeekTimeStamp();
  },
};

export const pickerOptionsOfAfterYesterday = {
  disabledDate: (time) => time.getTime() < getYesterdayTimeStamp(),
};

export const pickerOptionsOfAfterBeforeToday = {
  disabledDate: (time) => time.getTime() >= Date.now(),
};

export const pickerOptionsOfAfterToday = {
  disabledDate: (time) => time.getTime() <= Date.now(),
};

export const pickerOptionsOfAfterSystemStartDay = {
  disabledDate: (time) => time.getTime() < new Date('2009-01-01 00:00:00').getTime(),
};

export const pickerOptionsBetweenSystemStartAndToday = {
  disabledDate: (time) => {
    const millisecond= time.getTime();
    return millisecond < new Date('2009-01-01 00:00:00').getTime() || millisecond >= Date.now()
  },
};

export const pickerOptionsStopCourseDelayDate = {
  disabledDate: (time) => {
    const millisecond= time.getTime();
    const currentTime = Date.now();
    return millisecond < currentTime - 86400000 * 366 || millisecond >= currentTime + 86400000 * 31;
  },
};

export const pickerOptionsBirthday = {
  disabledDate: (time) => {
    const millisecond= time.getTime();
    return millisecond < new Date('1900-01-01 00:00:00').getTime() || millisecond >= Date.now()
  },
};
